"use client"
import { useGetClients } from "@/lib/hooks/admin-dashboard/clients/get/useGetClients";
import Image from "next/image";
import React from "react";

const Clients = () => {
  const { data, isLoading } = useGetClients();
  const clients = data as Client[];
  if (isLoading) return <p>Loading...</p>;
  return (
    <section>
      <div className="text-2xl text-[#182F5C] font-bold sm:font-normal sm:text-[50px] uppercase flex flex-col gap-1 sm:gap-4 items-center">
        <h2>OUR HAPPY CLIENTS</h2>
        <span className="h-[2px] w-[10rem] bg-skillsewa-primary" />
      </div>
      <div className="mt-10 sm:mt-0 flex flex-wrap gap-10 items-center justify-center">
        {clients.map((client) => (
          <Image
            key={client._id}
            src={client.imageUrl}
            alt={client.name}
            height={100}
            width={100}
            // className="object-cover rounded-lg"
          />
        ))}
        {/* <Image
          src={"/assets/site/landing/clients/one.jpg"}
          height={100}
          width={100}
          alt="Featured In"
        />
        <Image
          src={"/assets/site/landing/clients/two.png"}
          height={100}
          width={100}
          alt="Featured In"
        />
        <Image
          src={"/assets/site/landing/clients/three.png"}
          height={100}
          width={100}
          alt="Featured In"
        />
        <Image
          src={"/assets/site/landing/clients/four.jpg"}
          height={100}
          width={100}
          alt="Featured In"
        />
        <Image
          src={"/assets/site/landing/clients/five.jpg"}
          height={100}
          width={100}
          alt="Featured In"
        />
        <Image
          src={"/assets/site/landing/clients/six.jpg"}
          height={100}
          width={100}
          alt="Featured In"
        />
        <Image
          src={"/assets/site/landing/clients/seven.jpg"}
          height={100}
          width={100}
          alt="Featured In"
        /> */}
      </div>
    </section>
  );
};

export default Clients;
